import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import * as ImageUrl from "../../../constants/constant.js";
import * as constant from "../../../constants/constant.js";
import { bindActionCreators } from 'redux';
import * as appointmentActions from '../../../actions/appointmentActions.js';
import * as disputeActions from '../../../actions/disputeActions.js';
import { ToastContainer, toast } from 'react-toastify';
import ReactLoading from 'react-loading';
import 'react-toastify/dist/ReactToastify.css';
import Reaptcha from 'reaptcha';
import '../../../styles/css/dispute.css'
import { Button, Form, FormGroup, Label, Input, Alert } from 'react-bootstrap';
import DisputeSubmitForm from './disputeSubmitForm.js';
import DisputeHeader from './disputeHeader.js';
// {constant.PRODUCTION_IMAGE_URL + 'patientImage/' + image}
const size = 10;
let btnSize = { fontSize: '13' };
class Dispute extends React.Component {
    constructor(props, context) {
        super(props);
        this.state = {
            logoutButton: false,
            disputeList: [],
            subDisputeDetail: [],
            isLoader: false,
            wasItHelpful: false,
            wasItHelpfulButton: false,
            isAppointmentDataFetched: false,
            subDisputeListShow: false,
            subDisputeList: [],
            selectedDispute: '',
            selectedSubdispute: '',

        };
        this.handleOutsideClick = this.handleOutsideClick.bind(this);
        this._logout = this._logout.bind(this);

    }
    componentWillMount() {
        let subDisputeId = this.props.match.params.subDisputeId;
        console.log("****--->>>><<<---*****", !subDisputeId, subDisputeId)
        if (!subDisputeId) {
            let disputeId = this.props.match.params.disputeId;
            this.props.disputeactions.getSubdisputeList({ disputeId });
            this.setState({ subDisputeListShow: true })
        } else {
            this.setState({ subDisputeListShow: false })
            let disputeObj = {
                subDisputeId: subDisputeId,
            };
            let objectDocument = {
                appointmentId: this.props.match.params.appointmentId
            }
            // this.props.appointmentactions.getAppointmentDetails(objectDocument)
            this.props.disputeactions.getSubdisputeDetail(disputeObj);
        }
    }
    componentWillReceiveProps(nextProps) {
        console.log('nextProps:', !this.state.isAppointmentDataFetched, nextProps.appointmentDetails.appointmentDetails)
        if (!this.state.isAppointmentDataFetched && nextProps.appointmentDetails && nextProps.appointmentDetails.appointmentDetails) {
            this.setState({
                // ...this.state,
                appointmentDetail: nextProps.appointmentDetails.appointmentDetails,
                // wasItHelpful: true,
                isAppointmentDataFetched: true,
                wasItHelpfulButton: true,
                wasItHelpful: false
            }, () => {
                console.log("appointment details ", this.state)
            })
        }
        let subDisputeId = this.props.match.params.subDisputeId;
        if (!subDisputeId && nextProps.dispute && nextProps.dispute.subDisputeList) {
            // let disputeList = nextProps.dispute.subDisputeDetail.dispute;
            let disputeList = nextProps.dispute.subDisputeList.dispute;

            this.setState({
                ...this.state,
                subDisputeList: nextProps.dispute.subDisputeList.subDispute,
                isLoader: false,
                disputeList,
                subDisputeListShow: true,
                wasItHelpfulButton: false,


            }, () => {
                console.log("------PPPPPAFTEr SETTING SUBDISPUTE$LIST", this.state)

            })
        }
        if (subDisputeId && nextProps.dispute && nextProps.dispute.subDisputeDetail) {
            let disputeList = nextProps.dispute.subDisputeDetail.dispute;
            let subDisputeDetail = nextProps.dispute.subDisputeDetail.subDispute;
            this.setState({
                ...this.state,
                disputeList,
                subDisputeDetail,
                isLoader: false,
                subDisputeListShow: false,
                // wasItHelpfulButton: false,
                wasItHelpful: false,
                appointmentDetail: nextProps.appointmentDetails && nextProps.appointmentDetails.appointmentDetails,

                // wasItHelpful: false,
            }, () => {
                console.log("disputelIst", this.state)
            })
        }

    }
    handleOutsideClick = (e) => {
        // ignore clicks on the component itself
        if (this.node && this.node.contains(e.target)) {
            return;
        }

        this.handleClick();
    }
    handleClick = () => {
        if (!this.state.logoutButton) {
            // attach/remove event handler
            document.addEventListener('click', this.handleOutsideClick, false);
        } else {
            document.removeEventListener('click', this.handleOutsideClick, false);
        }

        this.setState(prevState => ({
            logoutButton: !prevState.logoutButton,
        }));
    }
    _logout(event) {

        let userId = localStorage.getItem("userId");
        this.props.actions.logout({ 'userId': userId });

        event.preventDefault();
        localStorage.clear();
        this.props.history.push("/");
    }
    wasItHelpfulOption = (option) => {
        if (option == false) {
            let objectDocument = {
                appointmentId: this.props.match.params.appointmentId,
                isPastAppointment: true,
                isDisputed: true
            }
            this.props.appointmentactions.getAppointmentDetails(objectDocument)
        }
        this.setState({ wasItHelpfulButton: !option, wasItHelpful: false, isAppointmentDataFetched: false, })
    }
    submitDispute = () => {

        this.setState({ wasItHelpful: true })
    }
    submitDisputeToZendesk = (data) => {
        console.log('data:', data)
        this.props.disputeactions.submitDisputeToZendesk(data, this.props);
        // this.setState({ wasItHelpful: true })
    }

    fetchSubDisputeList = (data) => {
        // let disputeId = this.props.match.params.disputeId;
        console.log("------------> ", data)
        this.setState({ subDisputeListShow: true, selectedDispute: data.title })
        this.props.disputeactions.getSubdisputeList({ disputeId: data._id });
    }
    fetchSubDisputeDetail = (data) => {
        // let disputeId = this.props.match.params.disputeId;
        // this.setState({subDisputeListShow: false, selectedSubdispute: data.title })
        this.props.disputeactions.getSubdisputeDetail({ subDisputeId: data._id });
    }
    componentDidUpdate(prevProps, prevState) {
        Object.entries(this.props).forEach(([key, val]) =>
            prevProps[key] !== val && console.log(`Prop '${key}' changed ---> ${val}`)
        );
        if (this.state) {
            Object.entries(this.state).forEach(([key, val]) =>
                prevState[key] !== val && console.log(`State '${key}' changed---> ${val}`)
            );
        }
    }
    render() {
		var user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
        if (user && user.gender == undefined) {
            user = { ...user, gender: 'Male' }
            // localStorage.setItem('user', JSON.stringify(user));
            // user = JSON.parse(localStorage.getItem("user"));
        }
        // var gender = localStorage.getItem('user')
        var defaultImagePath = (user && user.gender) == 'Male' ?
            constant.PRODUCTION_IMAGE_URL + "uploads/common/patient_m.png" : constant.PRODUCTION_IMAGE_URL + "uploads/common/patient_f.png";
        var imagePath = ''
        if (user && user.image == "noUserImage.jpg") {
            imagePath = user && user.gender == 'Male' ?
                constant.PRODUCTION_IMAGE_URL + "uploads/common/patient_m.png" : constant.PRODUCTION_IMAGE_URL + "uploads/common/patient_f.png";
        } else {
            imagePath =
                ImageUrl.PRODUCTION_IMAGE_URL +
                "uploads/" +
                localStorage.getItem("userId") +
                "/" +
                (user && user.image);
        }
        let disputeListRow = [];
        let subDisputeListRow = [];
        let disputeList = this.state.disputeList;
        let subDisputeList = this.state.subDisputeList;
        subDisputeList.length > 0 && subDisputeList.map(dispute => {
            let disputeListingJSX = <Link key={dispute._id} to={`/dispute/${this.props.match.params.appointmentId}/${this.props.match.params.disputeId}/${dispute._id}`}
                className={this.props.match.params.disputeId == dispute._id ? "nav-link active" : 'nav-link'}
                onClick={() => this.fetchSubDisputeDetail(dispute)}
                id="v-pills-home-tab"
                // data-toggle="pill"
                role="tab"
                aria-controls="v-pills-home"
                aria-selected="true">{dispute && dispute.title}</Link>
            subDisputeListRow.push(disputeListingJSX)
        })
        let selectedDispute;
        disputeList.length > 0 && disputeList.map(dispute => {
            dispute._id == this.props.match.params.disputeId ? selectedDispute = dispute.title : null;
            let disputeListingJSX = <Link key={dispute._id} to={`/dispute/${this.props.match.params.appointmentId}/${dispute._id}`}
                className={this.props.match.params.disputeId == dispute._id ? "nav-link active" : 'nav-link'}
                onClick={() => this.fetchSubDisputeList(dispute)}
                id="v-pills-home-tab"
                // data-toggle="pill"
                role="tab"
                aria-controls="v-pills-home"
                aria-selected="true">{dispute && dispute.title}</Link>
            disputeListRow.push(disputeListingJSX)
        });
        // this.setState({selectedDispute: selectedDispute})
        console.log("disputeListERo", selectedDispute)
        return (
            <div className="wrapper">
                {this.state.isLoader ? <div className="loaderCenter"> <ReactLoading type={'bars'} color={'blue'} /></div> :
                    (<React.Fragment>
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-12">
                                    <DisputeHeader inputRef={el => this.inputElement = el} _logout={this._logout} handleClick={this.handleClick} logoutButton={this.state.logoutButton} />

                                </div>
                            </div>
                        </div>



                        <div className="search-bar">
                            <div className="container-fluid">


                                <div className="topnav d-flex">
                                    <h3>We're here to help</h3>
                                    <div className="search-container ">
                                        <form action="/action_page.php">
                                            <input type="text" placeholder="Search.." name="search"></input>
                                            <button type="submit" className="btn btn-warning btn-md">Search</button>
                                        </form>
                                    </div>
                                </div>


                            </div>
                        </div>



                        <div className="dispute-options">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-3 col-md-2">
                                        <div className="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                                            {disputeListRow}
                                            {/* <a className="nav-link active" id="v-pills-home-tab" data-toggle="pill" href="#v-pills-home" role="tab" aria-controls="v-pills-home" aria-selected="true">general</a>
                                    <a className="nav-link" id="v-pills-profile-tab" data-toggle="pill" href="#v-pills-profile" role="tab" aria-controls="v-pills-profile" aria-selected="false">payments and refunds</a>
                                    <a className="nav-link" id="v-pills-messages-tab" data-toggle="pill" href="#v-pills-messages" role="tab" aria-controls="v-pills-messages" aria-selected="false">category 3</a>
                                    <a className="nav-link" id="v-pills-settings-tab" data-toggle="pill" href="#v-pills-settings" role="tab" aria-controls="v-pills-settings" aria-selected="false">category 4</a> */}
                                        </div>
                                    </div>
                                    <div className="col-9 col-md-10">
                                        <div className="tab-content" id="v-pills-tabContent">
                                            <div className="tab-pane fade show active" id="v-pills-home" role="tabpanel" aria-labelledby="v-pills-home-tab">
                                                <div className="breadCrumbs mb-4"><a href="#">disputes</a> > <Link to={`/dispute/${this.props.match.params.appointmentId}/${this.props.match.params.disputeId}`} onClick={() => this.fetchSubDisputeList({ _id: this.props.match.params.disputeId })}>{selectedDispute}</Link></div>
                                                {this.state.subDisputeListShow ? <div>{subDisputeListRow}</div>
                                                    : <div>
                                                        <div className="content-block">
                                                            <p>{this.state.subDisputeDetail && this.state.subDisputeDetail.description}</p>
                                                            {/* <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form,
                                                       by injected humour, or randomised words which don't look even slightly believable.
                                                     If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in</p> */}
                                                        </div>


                                                        <div className="dispute-form">
                                                            <div className="helpheading">
                                                                <div><span>Did this resolve your issue?</span> <ul className="clearfix"><li><a onClick={() => this.wasItHelpfulOption(true)} style={{ "cursor": "pointer" }}>Yes</a></li><li>/</li><li><a onClick={() => this.wasItHelpfulOption(false)} style={{ "cursor": "pointer" }}>No</a></li></ul></div>
                                                                {this.state.wasItHelpfulButton/*  && this.state.isAppointmentDataFetched */ ? <a className="btn btn-warning" style={{ color: "white" }} onClick={this.submitDispute}>Submit an Issue</a> : ''}
                                                            </div>
                                                            {this.state.wasItHelpful /* && this.state.isAppointmentDataFetched */ ? <DisputeSubmitForm appointmentDetail={this.state.appointmentDetail} subDisputeDetail={this.state.subDisputeDetail} submitDispute={this.submitDisputeToZendesk} /> : ''}

                                                        </div>
                                                    </div>
                                                }</div>




                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>








                        <footer className="text-center colorFooter">
                            <div className="container">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <ul className="foterList">
                                            <li className="b-r">
                                                <Link to="#">
                                                    <img src={require('../../../images/images/footer_logo.png')} className="m-b-15" alt="" />
                                                </Link>
                                                <Link to="/apps">
                                                    <img src={require('../../../images/images/appstore_footer.png')} className="m-b-10" alt="" />
                                                </Link>
                                                <Link to="/apps">
                                                    <img src={require('../../../images/images/playstore_Footer.png')} alt="" />
                                                </Link>
                                            </li>
                                            <li className="b-r">
                                                <div className="listCompanyItem">
                                                    <h4>Our Company</h4>
                                                    <ul className="CompnayList">
                                                        <li>
                                                            <Link to="/marketing/about-us">
                                                                About us</Link>
                                                        </li>
                                                        <li>
                                                            <Link to="/marketing/contact-us">
                                                                Contact Us</Link>
                                                        </li>
                                                        <li>
                                                            <Link to="/marketing/terms">
                                                                Terms &amp; Conditions</Link>
                                                        </li>
                                                        <li>
                                                            <Link to="/marketing/privacy">
                                                                Privacy Policy</Link>
                                                        </li>
                                                        <li>
                                                            <Link to="/marketing/quality">
                                                                Quality &amp; Transparency</Link>
                                                        </li>
                                                        <li>
                                                            <Link to="/marketing/support-centre">
                                                                Support Centre</Link>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </li>
                                            <li className="b-r">
                                                <div className="ft-link-block listCompanyItem">
                                                    <h4>For Patients</h4>
                                                    <ul className="CompnayList">
                                                        <li>
                                                            {/* <Link to="#" onClick={this.openSignInModal.bind(this, '1')} to="">Sign In</Link> */}
                                                        </li>
                                                        <li>
                                                            {/* <Link to="#" onClick={this.openSignUpModal.bind(this, '1')} to="">Sign Up</Link> */}
                                                        </li>
                                                        <li>
                                                            <Link to="#">
                                                                Find a Specialist </Link>
                                                        </li>
                                                        <li>
                                                            <Link to="/#Benifits">
                                                                Benefits of the ER App</Link>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </li>
                                            <li className="b-r">
                                                <div className="ft-link-block listCompanyItem">
                                                    <h4>For Specialists</h4>
                                                    <ul className="CompnayList">
                                                        <li>
                                                            {/* <Link to="#" onClick={this.openSignInModal.bind(this, '2')} to="">Sign In</Link> */}
                                                        </li>
                                                        <li>
                                                            {/* <Link to="#" onClick={this.openSignUpModal.bind(this, '2')} to="">Sign Up</Link> */}
                                                        </li>
                                                        <li>
                                                            <Link to="#" href="for-specialist/#Joinus">
                                                                Why Join Us?</Link>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="ft-link-block listCompanyItem">
                                                    <h4>Apps</h4>
                                                    <ul className="CompnayList">
                                                        <li>
                                                            <Link to="/marketing/apps">
                                                                Patient Android App</Link>
                                                        </li>
                                                        <li>
                                                            <Link to="/marketing/apps">
                                                                Patient iOS App</Link>
                                                        </li>
                                                        <li>
                                                            <Link to="/marketing/apps">
                                                                Specialists Android App </Link>
                                                        </li>
                                                        <li>
                                                            <Link to="/marketing/apps">
                                                                Specialists iOS App</Link>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-12 text-center">
                                        <ul className="list-inline social-icon">
                                            <li className="m-5">
                                                <Link to="#">
                                                    <i className="fa fa-facebook"></i>
                                                </Link>
                                            </li>
                                            <li className="m-5">
                                                <Link to="#">
                                                    <i className="fa fa-twitter"></i>
                                                </Link>
                                            </li>
                                            <li className="m-5">
                                                <Link to="#">
                                                    <i className="fa fa-google"></i>
                                                </Link>
                                            </li>
                                            <li className="m-5">
                                                <Link to="#">
                                                    <i className="fa fa-pinterest-p"></i>
                                                </Link>
                                            </li>
                                            <li className="m-5">
                                                <Link to="#">
                                                    <i className="fa fa-linkedin"></i>
                                                </Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="copyright">
                                <div className="">
                                    <div className="">
                                        {/* 
               <p className="copyTxt">Copyright &copy; MyCompany. All rights reserved.</p>
               */}
                                        <p className="copyTxt">Medfix © 2018. All rights reserved.</p>
                                    </div>
                                </div>
                            </div>
                        </footer>
                    </React.Fragment>
                    )}
            </div>
        );
    }
}

//this tells what state should expose on props
function mapStateToProps(state, ownProps) {
    return {
        dispute: state.dispute,
        appointmentDetails: state.appointment,
        // specialistPatients: state.specialist.specialistPatients
    };
}
//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(appointmentActions, dispatch),
        disputeactions: bindActionCreators(disputeActions, dispatch),
        appointmentactions: bindActionCreators(appointmentActions, dispatch),

    };
}
export default connect(mapStateToProps, mapDispatchToProps)(Dispute);